import { setHardwareTriggerMode } from '@/tauri/dictation/api';
import { logger } from '@/utils/logger/logger';
import {
  DEFAULT_DICTAPHONE_TRIGGER_MODE,
  dictaphoneTriggerModeAtom,
} from '@heidi/dictate/data';
import { sanitizeError } from '@heidi/runtime/logger';
import { useAtomValue } from 'jotai';
import { useEffect } from 'react';

/**
 * Pushes the dictaphone trigger mode to Rust on boot and on every change, so
 * Rust (default double press) catches up. The dictaphone gate (either device
 * phase flag) is the kill switch, same as the Settings control: with it off
 * the device falls back to double press, whatever the stored choice.
 */
export function useDictaphoneTriggerModeSync(hardwareMicEnabled: boolean): void {
  const stored = useAtomValue(dictaphoneTriggerModeAtom);
  const mode = hardwareMicEnabled ? stored : DEFAULT_DICTAPHONE_TRIGGER_MODE;
  useEffect(() => {
    void Promise.resolve(setHardwareTriggerMode(mode)).catch((error: unknown) => {
      logger.error({
        event_type: 'DICTATION_HARDWARE_TRIGGER_MODE_SYNC_FAILED',
        details: { error: sanitizeError(error) },
      });
    });
  }, [mode]);
}
